export default "__VITE_ASSET__CgwBubYS__"